import { render, staticRenderFns } from "./SBPrescriptions.vue?vue&type=template&id=74dc620a"
import script from "./SBPrescriptions.vue?vue&type=script&lang=js"
export * from "./SBPrescriptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports